import { useState } from 'react';
import PaginationCustom from '../../../../../components/Assets/PaginationCustom';
import IndividualCircularLoader from '../../../../../components/Loader/IndividualCircularLoader';
import { similariesTableHeader } from '../../../constant';
import AdsTable from '../../adsTable/AdsTable';
import styles from './similarAds.module.scss';
import SimilarAdsContainer from './SimilarAdsContainer';

interface ISimilarAdsProps {
  ad: Ad | null;
}

const display = 20;

function SimilarAds({ ad }: ISimilarAdsProps) {
  const [minIndexTab, setMinIndexTab] = useState<number>(0);

  if (!ad) {
    return (
      <SimilarAdsContainer>
        <IndividualCircularLoader size={200} />
      </SimilarAdsContainer>
    );
  }

  if (!ad?.children.length) {
    return (
      <SimilarAdsContainer>
        <div className={styles.noContent}>
          <p>Aucune annonce similaire trouvée</p>
        </div>
      </SimilarAdsContainer>
    );
  }

  return (
    <SimilarAdsContainer>
      <AdsTable
        columnTitles={similariesTableHeader}
        ads={ad.children}
        needCheck={false}
        display={display}
        minIndexTab={minIndexTab}
      />
      <PaginationCustom
        elementsQty={ad.children.length}
        itemsPerPage={display}
        handleMinIndexTab={setMinIndexTab}
      />
    </SimilarAdsContainer>
  );
}

export default SimilarAds;
